(function () {
  'use strict';

  var storageKey = 'empire_attribution_v1';
  var endpoint = 'https://shopmonkey-attribution.shannon-849.workers.dev/leads/shopify';

  function clean(value, maxLength) {
    return String(value || '').trim().slice(0, maxLength);
  }

  function readStored() {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || '{}');
    } catch (error) {
      return {};
    }
  }

  function writeStored(value) {
    try {
      localStorage.setItem(storageKey, JSON.stringify(value));
    } catch (error) {}
  }

  function firstValue(data, names) {
    for (var index = 0; index < names.length; index += 1) {
      var value = data.get(names[index]);
      if (value) return value;
    }
    return '';
  }

  function captureAttribution() {
    var params = new URLSearchParams(window.location.search);
    var existing = readStored();
    var clickId = params.get('gclid') || params.get('gbraid') || params.get('wbraid') || '';
    var utmSource = params.get('utm_source') || '';
    var utmMedium = params.get('utm_medium') || '';
    var hasCampaignData = Boolean(clickId || utmSource || utmMedium || params.get('utm_campaign'));

    if (!existing.landingPage) {
      existing.landingPage = window.location.href;
      existing.referrer = document.referrer || '';
    }

    if (hasCampaignData) {
      existing.gclid = clickId;
      existing.campaign = params.get('utm_campaign') || '';
      existing.adGroup = params.get('utm_adgroup') || params.get('utm_term') || '';
      existing.utmSource = utmSource;
      existing.utmMedium = utmMedium;
      existing.capturedAt = new Date().toISOString();
    }

    if (clickId || (utmSource.toLowerCase() === 'google' && /cpc|ppc|paid/.test(utmMedium.toLowerCase()))) {
      existing.originalSource = 'Google Ads';
    } else if (!existing.originalSource) {
      var referrer = existing.referrer || '';
      if (/google\./i.test(referrer)) existing.originalSource = 'Google Organic';
      else if (referrer && !/empirelinex\.com/i.test(referrer)) existing.originalSource = 'Website Referral';
      else existing.originalSource = 'Website - Direct';
    }

    writeStored(existing);
    return existing;
  }

  function isLeadForm(form) {
    var formType = form.querySelector('[name="form_type"]');
    return form.action.indexOf('/contact') !== -1 || Boolean(formType && formType.value === 'contact');
  }

  function sendLead(form) {
    if (!isLeadForm(form) || form.dataset.attributionSent === 'true') return;

    var data = new FormData(form);
    var attribution = captureAttribution();
    var payload = {
      name: clean(firstValue(data, ['contact[Name]', 'contact[name]', 'name']), 160),
      phone: clean(firstValue(data, ['contact[Phone]', 'contact[phone]', 'phone']), 40),
      email: clean(firstValue(data, ['contact[email]', 'contact[Email]', 'email']), 160),
      service: clean(firstValue(data, ['contact[Service]', 'contact[service]', 'contact[Subject]', 'contact[subject]']) || form.id || document.title, 300),
      location: 'Rancho Cucamonga',
      landingPage: clean(attribution.landingPage || window.location.href, 500),
      originalSource: clean(attribution.originalSource, 120),
      campaign: clean(attribution.campaign, 200),
      adGroup: clean(attribution.adGroup, 200),
      gclid: clean(attribution.gclid, 300),
      website: clean(window.location.pathname, 300)
    };

    if (!payload.phone && !payload.email) return;

    form.dataset.attributionSent = 'true';
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      keepalive: true,
      credentials: 'omit'
    }).catch(function () {
      form.dataset.attributionSent = 'false';
    });
  }

  captureAttribution();
  document.addEventListener('submit', function (event) {
    if (event.target instanceof HTMLFormElement) sendLead(event.target);
  }, true);
})();